import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../common/spinner';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';

const SearchResultsMessage = ({
  fetchStatus,
  resultsCount,
  searchTerm
}) => {
  if (fetchStatus === 'fetchingOnSamePage') {
    return <Spinner inline />;
  }
  if (!searchTerm) {
    return null;
  }
  return (
    <div className="module notification">
      <RosettaFormattedMessage parentFilename={__filename}
        id="message"
        description="Message displayed when search results are not empty"
        defaultMessage={`{resultsCount, plural,
          =0    {Bummer! 0 results found}
          one   {Cha-ching! 1 result found.}
          other {Cha-ching! # results found.}
        }`}
        values={{ resultsCount }}
      />
    </div>
  );
};

SearchResultsMessage.propTypes = {
  fetchStatus: PropTypes.string.isRequired,
  resultsCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired
};

export default SearchResultsMessage;
